
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ticket-price",
      function () {
        return require("private-next-pages/ticket-price/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ticket-price"])
      });
    }
  